import { render, staticRenderFns } from "./tabs-list-cp.vue?vue&type=template&id=ff738e1e&scoped=true&"
import script from "./tabs-list-cp.vue?vue&type=script&lang=js&"
export * from "./tabs-list-cp.vue?vue&type=script&lang=js&"
import style0 from "./tabs-list-cp.vue?vue&type=style&index=0&id=ff738e1e&lang=scss&scoped=true&"
import style1 from "./tabs-list-cp.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff738e1e",
  null
  
)

export default component.exports